/**
 * Controls the behaviour of the scroll to top
 * @type {ScrollToTop}
 */
export class ScrollToTop {
    constructor() {
        // set vars
        this.button = document.querySelector('.js-scroll-to-top')
        this.hiddenClass = 'scroll-to-top--hidden'
        this.animateOutClass = 'scroll-to-top--animate-out'
        this.animateInClass = 'scroll-to-top--animate-in'

        // scroll event to visibility of scroll to top btn
        window.addEventListener('scroll', () => this.handleScrollToTop())

        // click event to scroll to top
        this.button.addEventListener('click', () => this.scrolling())
    }

    /**
     * scroll to top
     */
    scrolling() {
        // is supported? https://caniuse.com/element-scroll-methods
        try {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        } catch (e) {
            // try another way
            window.scrollTo(0, 0)
        }
    }

    /**
     * hide or set visible class for scroll to top button
     */
    handleScrollToTop() {
        let minScrollValue = window.innerHeight ? window.innerHeight * 0.8 : 1400
        let distanceFromTop = window.pageYOffset

        if (distanceFromTop > minScrollValue) {
            //animation in
            this.button.classList.remove(this.animateOutClass)
            this.button.classList.add(this.animateInClass)
            //not hidden
            this.button.classList.remove(this.hiddenClass)
        } else {
            if (this.button.classList.contains(this.animateInClass)) {
                //animation out
                this.button.classList.remove(this.animateInClass)
                this.button.classList.add(this.animateOutClass)
                //hidden
                this.button.classList.add(this.hiddenClass)
            }
        }
    }
}
